import { Inject, Injectable } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigRequestsInterface,
    ENDPOINTS,
    EXPANDS,
    InitializableInterface,
    UriUtilitiesService,
    UserMasterService,
} from '@evorait/pace-core';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConfigInterfaceService implements ConfigRequestsInterface, InitializableInterface {
    public isInitialized = false;
    public offlineStoreDefiningRequests: string[];

    private readonly commonEndpoints: string[];

    private readonly cseDopSetEndpoint = [ENDPOINTS.CseDopSet];

    private readonly bootStockEndpoint: string[];
    private readonly aaEndpoints: string[];
    public constructor(
        private readonly userMasterService: UserMasterService,
        private readonly uriUtilities: UriUtilitiesService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        this.commonEndpoints = [
            this.uriUtilities.appendParameter(
                ENDPOINTS.NotificationHeaders,
                this.uriUtilities.getNotificationHeaderByAppId(),
            ),
            ENDPOINTS.ValueHelpers,
            ENDPOINTS.ConfigSet,
            ENDPOINTS.InputFieldProperties,
            ENDPOINTS.WhatsNew,
        ];

        this.bootStockEndpoint = [
            this.uriUtilities.appendParameter(ENDPOINTS.MaterialStockSet, EXPANDS.MaterialStockAvailability),
        ];

        this.aaEndpoints = [this.uriUtilities.appendParameter(ENDPOINTS.WorkScheduleSet, EXPANDS.WorkSchedule)];
    }

    /**
     * Initializes configuration parameters that depend on the app id. Since the class is only used statically, there is
     * no new instance created ever and we need to call a static initializer function to fill our definingRequests array.
     *
     * @returns {Observable<string[]>} - An observable that emits the defining requests.
     */
    public init(): Observable<string[]> {
        const userModel = this.userMasterService.getSelectedUserModel();

        this.offlineStoreDefiningRequests = this.commonEndpoints;

        // Add defining requests specific for P58 apps
        if (this.clientManager.isNgmP58()) {
            this.offlineStoreDefiningRequests = this.offlineStoreDefiningRequests.concat(this.cseDopSetEndpoint);

            const bootStockEndpointWithFilters = this.uriUtilities.appendFiltersForDefiningRequests(
                this.bootStockEndpoint,
                userModel,
            );
            this.offlineStoreDefiningRequests = this.offlineStoreDefiningRequests.concat(bootStockEndpointWithFilters);
        }

        // Append filter for NGMAA defining requests
        if (this.clientManager.isNgmAP0()) {
            this.offlineStoreDefiningRequests = this.offlineStoreDefiningRequests.concat(this.cseDopSetEndpoint);

            this.offlineStoreDefiningRequests = this.offlineStoreDefiningRequests.concat(this.aaEndpoints);

            this.offlineStoreDefiningRequests = this.offlineStoreDefiningRequests.concat(this.bootStockEndpoint);

            this.offlineStoreDefiningRequests = this.uriUtilities.appendFiltersForDefiningRequests(
                this.offlineStoreDefiningRequests,
                userModel,
            );
        }

        this.isInitialized = true;

        return of(this.offlineStoreDefiningRequests);
    }
}
